import { IToastProps, ToastDuration, toastsStore } from '~/view/containers/Toasts';

export const toastError = ({ id, title, message, duration }: IToastProps) => {
  toastsStore.addToast({
    id,
    iconType: 'error',
    title,
    message,
    duration,
  });
};

export const toastSuccess = ({ id, title, message, duration = ToastDuration.MEDIUM }: IToastProps) => {
  toastsStore.addToast({
    id,
    iconType: 'success',
    title,
    message,
    duration,
  });
};

export const toastNeutral = ({ id, title, message, duration }: IToastProps) => {
  toastsStore.addToast({
    id,
    title,
    message,
    duration,
  });
};

export const removeToast = (id: string) => {
  toastsStore.removeToast(id);
};
